<header class="header">
  <div class="header-inner">
    <a
      href="https://virginmobile.co"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Ir a Virgin Mobile"
      class="brand-link"
    >
      <img
        src="/images/virgin.png"
        alt="Virgin Mobile"
        class="brand-logo"
        width="140"
        height="44"
      />
    </a>
  </div>
</header>
